const tabs = {
  roulette: [],
  popular: ['bsw-egypt'],
  nuevo: [
    'bsw-luxorguardians3',
    "bsw-cleoteam",
    "bsw-hawaiitopia",
    "bsw-spacewins",
  ]
};

function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}
function formatGameId(gameId) {
  return gameId.replace('b-', 'bsw-')
}

export { getTab, formatGameId };
